import { PREMIUM } from '../constants'
import {defaultPremiumState} from '../../defaulState'


const premiumReducer = (state = defaultPremiumState, action) => {
    let _newState = {}

    switch (action.type) {

        case PREMIUM.UPDATE_WIDGET_PREMIUM_AND_TRIAL:
            _newState = { ...state }
            const userInTrialMode = action.payload.userInTrialMode && !action.payload.isProfessionalPremium && !action.payload.isSmartPremium
            const trialEndTime = (action.payload.isProfessionalPremium || action.payload.isSmartPremium) ? 0 : action.payload.trialEndTime
            _newState.isProfessionalPremium = action.payload.isProfessionalPremium
            _newState.isSmartPremium = action.payload.isSmartPremium
            _newState.userInTrialMode = userInTrialMode
            _newState.trialEndTime = trialEndTime
            _newState.showProfessionalPremiumSettings = action.payload.isProfessionalPremium || (userInTrialMode && trialEndTime > 0)
            _newState.showSmartPremiumSettings = action.payload.isSmartPremium || action.payload.isProfessionalPremium || (userInTrialMode && trialEndTime > 0)
            _newState.isDeveloper = action.payload.isDeveloper
            _newState.premiumForRateUsed = action.payload.premiumForRateUsed
            _newState.trialReminderOverWatched = action.payload.trialReminderOverWatched
            _newState.trialReminderTwoDaysWatched = action.payload.trialReminderTwoDaysWatched
            _newState.countdownNotificationWatched = action.payload.countdownNotificationWatched
            break;

        case PREMIUM.UPDATE_WIDGET_SOME_PREMIUM_PARAMS:
            _newState = { ...state, ...action.payload }
            
            break;

        default:
            _newState = state;
            break;
    }

    return _newState
}

export {premiumReducer}